import axiosClient from 'utils/axiosClient';
import api from 'api';
import {formData} from 'utils/helpers/formData';

const getScoreRequests = async (params?: any) => {
	const response = await axiosClient.get(api.RATING.SCORE_REQUESTS.SCORE_REQUESTS, {params});
	return response.data;
};

const getScoreRequestByID = async (id: number) => {
	const response = await axiosClient.get(api.RATING.SCORE_REQUESTS.SCORE_REQUESTS + `/` + id);
	return response.data;
};

const createScoreRequest = async (data: any) => {
	const response = await axiosClient.post(api.RATING.SCORE_REQUESTS.SCORE_REQUESTS, formData(data));
	return response.data;
};

const updateScoreRequest = async (data: any, id: number) => {
	const response = await axiosClient.patch(
		api.RATING.SCORE_REQUESTS.SCORE_REQUESTS + `/` + id,
		formData(data)
	);
	return response.data;
};

const rejectScoreRequest = async (id: number, data: any) => {
	const response = await axiosClient.patch(
		api.RATING.SCORE_REQUESTS.SCORE_REQUESTS + `/` + id + '/reject',
		data
	);
	return response.data;
};
const approveScoreRequest = async (id: number, data: any) => {
	const response = await axiosClient.patch(
		api.RATING.SCORE_REQUESTS.SCORE_REQUESTS + `/` + id + '/approve',
		data
	);
	return response.data;
};

const deleteScoreRequest = async (id: number) => {
	const response = await axiosClient.delete(api.RATING.SCORE_REQUESTS.SCORE_REQUESTS + `/` + id);
	return response.data;
};

const service = {
	getScoreRequests,
	getScoreRequestByID,
	createScoreRequest,
	updateScoreRequest,
	rejectScoreRequest,
	approveScoreRequest,
	deleteScoreRequest
};
export default service;
